// store.js
import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import productSlice from "../redux/features/productSlice";
import wishlistSlice from '../redux/features/wishlistSlice';
import thunk from "redux-thunk";

const reducers = combineReducers({
    productSlice,
    wishlist: wishlistSlice,
});

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['productSlice', 'wishlist']
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
    reducer: persistedReducer,
    middleware: [thunk],
    devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);
export default store;